import React from 'react';
import '../Tabs/Tabs.scss';

type TabPanelProps = {
  /** The TabLink target based off the id */
  target: string;
  /** The current selected tab to work out if the panel should be shown or not */
  selectedTab: string;
  /** Additional styles to wrap onto the component */
  className?: string;
  /** The elements to show under the panel */
  children?: React.ReactNode;
};
const TabPanel = ({
  target,
  selectedTab,
  className,
  children
}: TabPanelProps): JSX.Element => {
  if (selectedTab !== target) {
    return <></>;
  }

  return (
    <div id={`tabpanel-${target}`} className={className ?? ''}>
      {children}
    </div>
  );
};

export default TabPanel;
